import { useContentOverflow } from '../../../hooks'
import { FileIconPreview } from '../../FileIcon'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'

import { FILE_MULTI_VALUE_NAME } from './FileMultiValue.constants'

import * as styles from './FileMultiValue.module.css'

function FileMultiValue({
  additionalTooltipInfo,
  className = styles.FileMultiValue,
  iconSize = 24,
  item,
  name = FILE_MULTI_VALUE_NAME,
  showTooltip,
  textClassName = styles.text,
  onClick,
  ...textProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  function handleClick() {
    onClick?.(item.id)
  }

  return (
    <div className={className}>
      <FileIconPreview className={styles.icon} file={item} size={iconSize} />
      <FloatingTooltip
        content={
          <FloatingTooltipContentText
            additionalText={additionalTooltipInfo}
            text={item.name}
          />
        }
        disabled={!overflow && !showTooltip}
      >
        <Text
          {...textProps}
          className={textClassName}
          ref={setContentOverflowRef}
          onClick={handleClick}
        >
          {item[name]}
        </Text>
      </FloatingTooltip>
    </div>
  )
}

export default FileMultiValue
